'use client';

import {DEFAULT_LOCALE, isLocale, localeHref} from '@olympus-frontend/core/i18n';
import {NotFoundPage} from '@olympus-frontend/core/pages/not-found';
import {useParams} from 'next/navigation';
import {useTranslation} from 'react-i18next';

// not-found boundaries get no params, so the locale comes from useParams. Strings come
// from the layout's I18nProvider rather than a DICTIONARIES import: this is a client
// module, so importing the dictionaries would ship every locale's JSON in its chunk.
export default function LocaleNotFound() {
  const params = useParams<{locale: string}>();
  const locale = isLocale(params.locale) ? params.locale : DEFAULT_LOCALE;
  const {t} = useTranslation();

  return (
    <NotFoundPage
      title={t('page_not_found_title')}
      body={t('page_not_found_body')}
      ctaLabel={t('go_to_hompage')}
      ctaHref={localeHref(locale)}
      illustrationSrc="/not-found.svg"
    />
  );
}
